var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accessToken && _vm.getUrl)?_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.getUrl,"referrerpolicy":"no-referrer-when-downgrade","loading":"lazy","allow":"clipboard-write"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }